import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATED } from '@ngrx/router-store';
import { filter, map } from 'rxjs/operators';
import { AccountActions } from '../actions/account.actions';
import { Store } from '@ngrx/store';
import { withLatestFrom } from 'rxjs';
import { selectIsAuthenticated } from '../selectors/account.selectors';

@Injectable()
export class RouterEffects {
  constructor(
    private actions$: Actions,
    private store: Store
  ) {}

  loadAccountOnNavigation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ROUTER_NAVIGATED),
      withLatestFrom(this.store.select(selectIsAuthenticated)),
      filter(([action, isAuthenticated]) => isAuthenticated),  // Проверяем авторизацию
      map(() => AccountActions.getAccountData())
    )
  );
}
